import 'react-toastify/dist/ReactToastify.css';
import { MsalProvider } from "@azure/msal-react";
import './styles.css';
import { Pages } from './Pages';
import { AppInsightsContext, useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useLocation } from "react-router-dom";
import React from "react";
import { reactPlugin } from '../telemetry/telemetryService';
import type { IPublicClientApplication } from '@azure/msal-browser';
import SessionBoundary from '../auth/SessionBoundary';

function App({ msalInstance }: { msalInstance: IPublicClientApplication }) {
  const appInsights = useAppInsightsContext();
  const location = useLocation();

  React.useEffect(() => {
    if (appInsights) {
      appInsights.trackPageView({ name: location.pathname });
    }
  }, [appInsights, location]);

  return (
    <>
      <MsalProvider instance={msalInstance}>
        <AppInsightsContext.Provider value={reactPlugin}>
          <SessionBoundary><Pages /></SessionBoundary>
        </AppInsightsContext.Provider>
      </MsalProvider>
    </>
  );
}

export default App;
